import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import InternationalSearchService from './services/InternationalService'

export const getInternationalCompany = createAsyncThunk(
  'internationalSearch/searchList/GET_INTERNATIONAL_COMPANY',
  async (data, { rejectWithValue }) => {
    try {
      const response = await InternationalSearchService.getCompany(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
